/* ============
 * Getters for the auth module
 * ============
 *
 * The getters that are available on the
 * auth module.
 */

export const getAuthToken = state => state.token;

export default {
  getAuthToken,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js